import React from 'react'
import {Link} from "react-router-dom";
import FormPage from "../FormPage";
import InternationPhoneInput from "../../components/form/InternationPhoneInput";

export default class ProfileEdit extends FormPage {
    static path = '/profile';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel';

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
     * The title shown on the form
     */
    static FormTitle = "auth.edit_profile.title";

    /**
     * The api endpoint path that the form should send a post request to
     */
    static FormPost = "/api/sessions/update";

    /**
     * The submit button title for the form
     */
    static FormSubmit = "Update";

    /**
     * The fields mapping for the form
     */
    formFields() {
        return this.transFormFields([
            {
                style: styles.fieldSection,
                fields: {
                    first_name: {
                        label: 'auth.edit_profile.first_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    last_name: {
                        label: 'auth.edit_profile.last_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    email: {
                        label: 'auth.edit_profile.email_label',
                        type: 'email',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    phone: {
                        type: 'antd-input',
                        children: (
                            <InternationPhoneInput/>
                        ),
                        label: 'auth.edit_profile.phone_label',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    job_title: {
                        label: 'auth.edit_profile.job_label',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                    location: {
                        label: 'auth.edit_profile.location_label',
                        type: 'location',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                },
            }
        ]);
    }

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @param context
     * @returns {FormPage}
     */
    constructor(props, context) {
        super(props, context);
        let model = {...(context.auth || {})}
        if (model.phone) {
            let phoneNumber = model.phone.replace(/\D/g, '');
            if (phoneNumber?.length === 10 && !model.phone.includes('+')) {
                model.phone = "+1 " + model.phone;
            }
        }
        this.state = {
            ...this.state,
            model,
        };
    }

    /**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
    onSuccess(responseData) {
        TB.alert(
            'success',
            'auth.edit_profile.success.title',
            'auth.edit_profile.success.message'
        );

        TB.auth().update({...responseData.data.auth});
    }

    formTitle() {
        return (
            <div className="form-title-section talent-profile-form">

                <h3>Profile</h3>

                <div className="profile-form-btns">
                    <Link to="/talent/application" className="btn btn-primary">
                        Edit Client-Facing Profile
                    </Link>
                    <Link to={`/talent-profiles/${this.context.auth?.id}`} className="btn btn-dark">
                        {TB.trans('talent.dashboard.profile_overview_buttons.preview')}
                    </Link>
                </div>
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },

};